import { Input } from '@quickbit/qb-design-system';
import { getLabel } from 'tabs/ProcessingUsers/types';

interface Props {
  item: object;
  exclude?: string[];
}

export const RecursiveDisabledInput = ({ item, exclude = [] }: Props) => {
  return (
    <>
      {Object.entries(item).map(([key, field]) => (
        <>
          {typeof field === 'object' &&
            field !== null &&
            !exclude.includes(key) && (
              <RecursiveDisabledInput
                key={key}
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                item={field}
                exclude={exclude}
              />
            )}
          {(typeof field !== 'object' || field === null) &&
            !exclude.includes(key) && (
              <Input
                key={key}
                label={getLabel(key)}
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                value={field ?? '-'}
                disabled
                onChange={() => ({})}
              />
            )}
        </>
      ))}
    </>
  );
};
